import { getCompany } from 'common/api/v1/companies';

import { FETCH, FETCH_SUCCESS, FETCH_FAILURE } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

import initializeForm from './initializeForm';

export default () => (dispatch) => {
    dispatch(companyGeneralActions[FETCH]());

    getCompany()
        .then((response) => {
            dispatch(companyGeneralActions[FETCH_SUCCESS](response.data.data));
            dispatch(initializeForm(response.data.data));
        })
        .catch((error) =>
            dispatch(
                companyGeneralActions[FETCH_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
